module.exports = "<svg viewBox=\"0 0 24 24\"><path d=\"M1,17 L1,8 L3.75,8 L6.5,11.3088235 L9.25,8 L12,8 L12,17 L9.25,17 L9.25,11.8382353 L6.5,15.1470588 L3.75,11.8382353 L3.75,17 L1,17 Z M19,17 L15,12.6323529 L17.6666667,12.6323529 L17.6666667,8 L20.3333333,8 L20.3333333,12.6323529 L23,12.6323529 L19,17 Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./components/UI/Icon/images/markdown.svg
// module id = 763
// module chunks = 0